import type { StaffBootstrap } from "@/hooks/use-staff";

// Read the explicit capability; neither staff nor Finance management implies it.
export const staffCanSetPay = (data?: StaffBootstrap) =>
  (data as (StaffBootstrap & { canSetPay?: boolean }) | undefined)?.canSetPay === true;

export function withoutPayFields<T extends { payAmount?: unknown; payPer?: unknown }>(body:T) {
  const {payAmount: _amount,payPer: _per,...rest}=body;
  return rest;
}

export const staffStep8Text = (key:"missing"|"review"|"reviewed"|"reviewAction"|"managerNote"|"branch",rtl:boolean) => ({
  missing:rtl?"الأجر غير محدد، اطلب من المالية تحديده":"Pay not set, ask finance",
  review:rtl?"الإضافات والتغييرات":"Extras and changes",
  reviewed:rtl?"تم الاطلاع":"Seen",
  reviewAction:rtl?"تم الاطلاع":"Seen",
  managerNote:rtl?"تُسجّل الإضافات والتغييرات للمتابعة فقط، ولا تحتاج موافقة المالية.":"Extras and changes are tracked for information only; Finance approval is not required.",
  branch:rtl?"اصرف من صندوق فرع الموظفين نفسه. قسّم الموظفين من فروع مختلفة إلى دفعات منفصلة.":"Pay from the employees’ own branch box. Split different branches into separate batches.",
})[key];

export const managerPayBranchValid = (employees:{locationId:string}[],branchId?:string) =>
  !!branchId && employees.every(p=>p.locationId===branchId);

// Seeing a record does not remove it from Extras and changes.
export const payHasExtrasAndChanges = (record:{needsReview:boolean}) =>
  record.needsReview;

// Only unseen records offer the optional Finance acknowledgement.
export const payReviewPending = (record:{needsReview:boolean;reviewedAt:string|null}) =>
  record.needsReview && !record.reviewedAt;
